import { Validate } from "./validate";
import { displayGenericError, displayInputErrorMarkup, serviceNetworkError } from "./failhandler";

var login = (function () {
    "use strict";

    if ($('.loginpage').length > 0) {
        var win = $(window),
            body = $('body'),
            headerHeight = $('.header').height(),
            footerHeight = $('footer').height(),
            bHeight = body.innerHeight() - headerHeight - footerHeight,
            slides = $('.slides'),
            steps = $('.step-slides'),
            actionBox = $('.action-box'),
            showGuideDialog = $('.show-guide-dialog'),
            showGuideLink = $('.show-guide'),
            skipGuideLink = $('.skip-guide'),
            loginForm = $('.login-form'),
            loginResWrapper = $('.login-response-wrapper'),
            resetForm = $('.reset-password-form'),
            resetResWrapper = $('.reset-response-wrapper'),
            resetFromMailResWrapper = $('.reset-from-mail-response-wrapper'),
            registerForm = $('.register-form'),
            step1inputs = registerForm.find('.step1 input'),
            prevButton = $('#register-prev'),
            feedback = $('.feedback'),
            validated = true,
            click = 'click',
            cl = new CanvasLoader('loader');

        if (Modernizr.touch) {
            click = 'click touchend';
        }

        cl.setDiameter(32);
        cl.setDensity(90);
        cl.setRange(0.9);
        cl.setSpeed(3);
        cl.setColor('#666666');
        cl.setFPS(32);

        win.on('load', setPositions);
        win.on('resize', setPositions);
        body.on(click, '.go-register', showRegisterForm);
        body.on(click, '#back-to-login', showLoginForm);
        body.on(click, '.back-to-login-from-reset', hideResetShowLoginForm);
        body.on(click, '#register-next', nextStepHandler);
        body.on(click, '#register-prev', prevStepHandler);
        body.on(click, '#login-submit:not(.disabled)', submitLoginForm);
        body.on(click, '#reset-password', resetPasswordForm);
        body.on(click, '#reset-password-submit', submitResetForm);
        body.on(click, '.show-guide-dialog .action > a', chooseGuide);
        body.on(click, '#register-submit', submitRegisterForm);

        slides.css({ height: bHeight });

        // Reset password form.
        var url = window.location.href,
            resetPasswordFromMailForm = $('#reset-password-from-mail');

        if (resetPasswordFromMailForm.length > 0) {
            win.on('load', resetPasswordFromEmailForm);
            body.on(click, '#reset-password-from-mail-submit', submitResetPasswordFromEmailForm);
            resetPasswordFromMailForm.closest('.login-showing').addClass('login-reset');
        }

        setUsernameFromCookie();

        $(".form input").keypress(function (e) {
            if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
                var form = $(this).parents(".form");
                if (form.length > 0) {
                    var submitBtn = $(".default-submit", form);
                    if (submitBtn.length > 0) {
                        submitBtn.click();
                        return false;
                    }
                }
            }
            return true;
        });

    }

    function setUsernameFromCookie() {
        var userName = $.cookie("un");
        if (userName !== null && userName !== undefined && userName !== "") {
            $("#username", loginForm).val(userName);
            $("#saveusername", loginForm).attr('checked', 'checked');
        }
    }

    function setPositions(e) {
        var bWidth = body.innerWidth(),
            aWidth = actionBox.width(),
            aHeight = actionBox.height();

        bHeight = body.innerHeight() - headerHeight - footerHeight;

        if (e.type === 'load') {
            actionBox.show();
        }

        if (e.type === 'resize') {
            slides.css({ height: bHeight });
        }
    }

    function showRegisterForm(e) {
        e.preventDefault();

        if (actionBox.hasClass('register-showing')) return;

        actionBox.addClass('register-showing').removeClass('login-showing feedback-showing');
        loginForm.hide();
        resetForm.hide();
        feedback.hide();
        if (resetPasswordFromMailForm.length > 0) {
            resetPasswordFromMailForm.hide();
        }

        if (Modernizr.cssanimations) {
            actionBox.on('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', function (e) {
                registerForm.fadeIn(80);
                actionBox.off('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd');
            });
        } else {
            registerForm.fadeIn(80);
        }
    }

    function showLoginForm(e) {
        e.preventDefault();

        if (actionBox.hasClass('login-showing')) return;

        actionBox.addClass('login-showing').removeClass('register-showing');
        registerForm.hide();
        if (resetPasswordFromMailForm.length > 0) {
            resetPasswordFromMailForm.hide();
        }

        if (Modernizr.cssanimations) {
            actionBox.on('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', function () {
                loginForm.fadeIn(80);
                actionBox.off('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd');
            });
        } else {
            loginForm.fadeIn(80);
        }
    }

    function hideResetShowLoginForm(e) {
        e.preventDefault();
        resetForm.hide();
        loginForm.show();
        if (resetPasswordFromMailForm.length > 0) {
            resetPasswordFromMailForm.hide();
        }
    }

    function nextStepHandler() {

        var validateStep1 = true;

        step1inputs.each(function () {
            if (!Validate.validate.call($(this))) {
                validateStep1 = false;
            }
        });

        if (validateStep1) {
            prevButton.removeClass('error-on-prev');
            $(this).prev().hide();

            if (Modernizr.cssanimations) {
                steps.toggleClass('s2');
                $('.step2').removeClass('hidden');
            } else {
                $('.step2').removeClass('hidden');
                steps.animate({ marginLeft: '-708px' }, 300);
            }
        }
        else {
            $(this).prev().show();
        }

        return false;
    }

    function prevStepHandler() {
        if (Modernizr.cssanimations) {
            var s2 = $('.s2');
            s2.on('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', function (e) {
                $('.step2').addClass('hidden');
                s2.off('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd');
            });

            steps.toggleClass('s2');
        } else {
            steps.animate({ marginLeft: '0' }, 300, function () {
                $('.step2').addClass('hidden');
            });
        }
        return false;
    }

    function submitLoginForm(e) {

        e.preventDefault();

        var $this = $(this),
            form = $this.closest('.form'),
            inputs = form.find('.form-item input[type="text"], .form-item input[type="password"]'),
            inputsToValidate = form.find('.form-item input[data-required]'),
            responseWrap = $('.login-response-wrapper'),
            invalidMessage = responseWrap.attr('data-error-message'),
            data = { pageid: SETTINGS.pageid, language: SETTINGS.language },
            queryStrings = document.URL.split('?')[1],
            queryItems = [],
            hash;

        validated = true;

        inputs.each(function () {
            if (!Validate.validate.call($(this))) {
                validated = false;
                responseWrap.empty().text(invalidMessage).show();
            }
        });

        if (validated) {
            cl.show();
            loginForm.hide();

            inputs.each(function () {
                var $this = $(this),
                    type = $this.attr('type'),
                    name = $this.attr('name');

                data[name] = $this.val();
            });

            if (queryStrings != undefined) {
                queryStrings = queryStrings.split('&');
                for (var i = 0; i < queryStrings.length; i++) {
                    hash = queryStrings[i].split('=');
                    queryItems.push(hash[1]);
                    queryItems[hash[0]] = hash[1];
                }
            }

            if (typeof queryItems.ReturnUrl != undefined) {
                data['ReturnUrl'] = queryItems.ReturnUrl;
            }

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.login,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);

        } else {
            return;
        }

        function doneHandler(response) {
            if (response.Success) {
                var responseData = response.Data,
                    redirectUrl = responseData.RedirectUrl;

                cl.hide();

                if (responseData.ShowGuide) {
                    actionBox.addClass('show-guide-dialog-showing');
                    showGuideDialog.show();
                    skipGuideLink.attr('href', redirectUrl);
                    showGuideLink.attr('href', redirectUrl + '?ShowGuide=true');

                } else {
                    window.location = redirectUrl;
                }

                if ($("#saveusername", loginForm).is(':checked')) {
                    $.cookie("un", $("#username", loginForm).val(), { expires: 100 });
                }
                else {
                    $.cookie("un", '');
                }
            } else {
                loginForm.show();

                displayGenericError(loginResWrapper, response);
            }

            cl.hide();
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            cl.hide();
            loginForm.show();
            serviceNetworkError(loginResWrapper);
        }
    }

    function chooseGuide(e) {
        e.preventDefault();

        var $this = $(this),
            href = $this.attr('href'),
            disableGuide = $('#disable-guide');

        if (disableGuide[0].checked) {
            if (href.indexOf('?') != -1) {
                href += '&disableGuide=true';
            } else {
                href += '?disableGuide=true';
            }
        }

        window.location = href;
    }

    function resetPasswordForm(e) {
        e.preventDefault();

        loginForm.hide();
        resetForm.show();
    }

    function submitResetForm(e) {
        e.preventDefault();

        var $this = $(this),
            form = $this.closest('.form'),
            emailInput = form.find('#useremail'),
            data = { pageid: SETTINGS.pageid, language: SETTINGS.language };

        validated = true;

        emailInput.each(function () {
            validated = Validate.validate.call($(this));
        });

        if (validated) {

            data['Email'] = emailInput.val();

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.resetPassword,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);

        } else {
            return;
        }

        function doneHandler(response) {
            if (response.Success) {
                resetResWrapper.append(response.Data.Message);

            } else {
                displayGenericError(resetResWrapper, response);

                cl.hide();
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            serviceNetworkError(resetResWrapper);
        }
    }

    function resetPasswordFromEmailForm(e) {
        e.preventDefault();

        loginForm.hide();
        resetPasswordFromMailForm.show();
    }

    function submitResetPasswordFromEmailForm(e) {
        e.preventDefault();

        var $this = $(this),
            form = $this.closest('.form'),
            inputs = form.find('input'),
            data = { pageid: SETTINGS.pageid, language: SETTINGS.language };

        validated = true;
        resetFromMailResWrapper.empty();

        inputs.each(function () {
            validated = Validate.validate.call($(this));

            if (validated) {
                var fieldName = $(this).attr('fieldname'),
                    inputName = $(this).attr('name'),
                    value = $(this).val();

                if (fieldName) {
                    data[fieldName] = value;
                } else {
                    data[inputName] = value;
                }
            }
        });

        if (validated) {
            var ajaxRequest = $.ajax({
                url: SETTINGS.services.forms.methods.resetPasswordFromMail,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);

        } else {
            return;
        }

        function doneHandler(response) {
            if (response.Success) {
                form.find('.form-item').hide();
                form.find('.form-item action').hide();
                form.find('#reset-from-mail-success-wrapper').show();
            } else {
                displayGenericError(resetFromMailResWrapper, response);
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            serviceNetworkError(resetFromMailResWrapper);
        }
    }

    function submitRegisterForm(e) {
        e.preventDefault();

        var $this = $(this),
            form = $this.closest('.form'),
            inputs = form.find('.form-item input'),
            inputsToValidate = form.find('.form-item input[data-required]'),
            responseWrap = $('.form-message'),
            invalidMessage = responseWrap.attr('data-error-message'),
            data = {};

        validated = true;

        inputsToValidate.each(function () {
            if (!Validate.validate.call($(this))) {
                validated = false;
            }
        });

        if (validated) {
            $this.prop("disabled", true).attr("disabled", "disabled");
            inputs.each(function () {
                var $this = $(this),
                    type = $this.attr('type'),
                    name = $this.attr('name');

                if (type === 'checkbox') {
                    data[name] = $this[0].checked;
                } else {
                    data[name] = $this.val();
                }
            });

            $.ajax({
                url: SETTINGS.services.forms.methods.register,
                data: JSON.stringify(data),
                success: function (response) {
                    if (response.Success) {
                        showFeedback(response);
                        prevStepHandler();
                        prevButton.removeClass('error-on-prev');
                        inputs.val('').filter('[type="checkbox"]').removeAttr('checked');
                    } else {
                        displayGenericError(responseWrap, response);
                        displayInputErrorMarkup(form, response);

                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    serviceNetworkError(responseWrap);
                },
                complete: function () {
                    $this.prop("disabled", false).removeAttr("disabled")
                }
            });

        } else {
            if (step1inputs.hasClass('parsley-error')) {
                prevButton.addClass('error-on-prev');
            }
            responseWrap.empty().text(invalidMessage).show();
        }
    }

    function showFeedback(res) {

        registerForm.hide();
        actionBox.removeClass('register-showing').addClass('feedback-showing');
        cl.hide();

        if (Modernizr.cssanimations) {
            actionBox.on('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd', function () {
                feedback.fadeIn(80);
                actionBox.off('webkitTransitionEnd oTransitionEnd otransitionend transitionend msTransitionEnd');
            });
        } else {
            feedback.fadeIn(80);
        }
    }
})();